import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { IonIcon } from 'controls'

import styles from './styles'

const Collapser = ({
  hasContent = false,
  header,
  label,
  className,
  initOpen = false,
  children,
  disabled = false,
  inverted = false,
  onToggle
}) => {
  const [isOpen, setOpen] = useState(initOpen)

  const handleToggle = () => {
    const newOpenState = !isOpen
    setOpen(newOpenState)

    // Call onToggle callback if provided, passing the new state
    if (onToggle) {
      onToggle(newOpenState)
    }
  }

  return (
    <div className={classnames('collapser', className, { 'is-open': isOpen })}>
      <div
        className={classnames('collapser-header', { 'is-inverted': inverted })}
      >
        <button
          className="collapser-button"
          onClick={handleToggle}
          disabled={disabled}
        >
          {inverted && label}
          {!hasContent && (
            <IonIcon
              icon={isOpen ? 'md-close' : 'md-arrow-dropdown'}
              className="toggle-icon-collapser"
              size={isOpen ? 'medium' : 'large'}
            />
          )}
          {!inverted && label}
        </button>

        <span className="header">{header}</span>
      </div>
      <div className="content">{children}</div>

      <style jsx>{styles}</style>
    </div>
  )
}

Collapser.propTypes = {
  hasContent: PropTypes.bool,
  header: PropTypes.node,
  label: PropTypes.node,
  className: PropTypes.string,
  initOpen: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  inverted: PropTypes.bool,
  onToggle: PropTypes.func,
}

Collapser.defaultProps = {
  hasContent: false,
  header: null,
  label: null,
  className: '',
  initOpen: false,
  children: null,
  disabled: false,
  inverted: false,
  onToggle: null,
}

export default Collapser
